import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { C } from '../../../theme';
import { GAME_INVITES } from '../../chat/chatConstants';

// ============================================================
// GAME INVITE CARD
// Renders inside the message list when a game invite is received.
// Shows accept/decline buttons while in 'responding' state,
// then collapses to a status label once the game is started/completed.
// ============================================================
export default function GameInviteCard({
  msg, gameType, playUiState, activeGameSession,
  serverState, acceptAndPlay, declineGame
}) {
  // Only show action buttons for the most recent unanswered invite
  const isLatestInvite = msg.id === [...(serverState?.messages || [])]
    .reverse()
    .find(m =>
      m.sender_id !== serverState?.myUserId &&
      m.message_type === 'free_text' &&
      GAME_INVITES[m.system_message]
    )?.id;

  const showButtons = playUiState === 'responding' &&
    activeGameSession?.game_type === gameType &&
    isLatestInvite;

  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 1, px: 1 }}>
      <Paper elevation={2} sx={{
        p: 1.5, borderRadius: 2, maxWidth: 280,
        bgcolor: C.bgCard,
        border: `1px solid ${C.yellow}`
      }}>
        <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 0.5, color: C.yellow }}>
          🎮 {msg.system_message}
        </Typography>
        {showButtons ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, mt: 0.5 }}>
            <Button size="small" variant="contained" sx={{ fontSize: '0.75rem' }}
              onClick={() => acceptAndPlay()}>
              Sure, let's play!
            </Button>
            <Button size="small" variant="outlined" sx={{ fontSize: '0.75rem' }}
              onClick={() => declineGame("Let's play something else!")}>
              Let's play something else
            </Button>
            <Button size="small" variant="text" sx={{ fontSize: '0.72rem', color: C.textMuted }}
              onClick={() => declineGame("Not into games, sorry!")}>
              Not into games, sorry
            </Button>
          </Box>
        ) : (
          <Typography variant="caption" sx={{ color: C.textMuted }}>
            {playUiState === 'playing' ? '✅ Game started!' : '✅ Game completed'}
          </Typography>
        )}
      </Paper>
    </Box>
  );
}
